module.exports = __webpack_public_path__ + "img/03.6dc29950.jpg";